import { CRUDProjects } from '@/services/API/project';
import userService from '@/services/API/user';
import { getMunicipalities, getRegions } from '@/services/API/_common';
import { CRUDQuestionCategory } from '@/services/API/_crud';

export const CACHE_KEYS = {
  question_categories: 'question_categories',
  projects: 'projects',
  municipalities: 'municipalities',
  regions: 'regions',
  users: 'users',
};

const CACHE_REQUESTS = {
  [CACHE_KEYS.question_categories]: CRUDQuestionCategory.getAll,
  [CACHE_KEYS.projects]: CRUDProjects.getAll,
  [CACHE_KEYS.municipalities]: getMunicipalities,
  [CACHE_KEYS.regions]: getRegions,
  [CACHE_KEYS.users]: userService.publicUsers,
};

export default {
  name: 'cache',
  namespaced: true,
  state: {
    question_categories: {},
    projects: {},
    municipalities: {},
    regions: {},
    users: {},
  },
  getters: {
    cachedCategories: (state) => state[CACHE_KEYS.question_categories] || {},
    cachedCategory: (state) => (id) => state[CACHE_KEYS.question_categories][id] || {},
    cachedProject: (state) => (id) => state[CACHE_KEYS.projects][id] || {},
    cachedProjects: (state) => state[CACHE_KEYS.projects],
    cachedMunicipality: (state) => (id) => state[CACHE_KEYS.municipalities][id] || {},
    cachedRegion: (state) => (id) => state[CACHE_KEYS.regions][id] || {},
    cachedUser: (state) => (id) => state[CACHE_KEYS.users][id] || {},
  },

  // Загрузка происходит асинхронно
  actions: {
    async loadToCache({ state, commit }, { key, ids = [] }) {
      if (!ids.length) return;

      const searchedIds = Array.from(new Set([...ids]))
        .filter(Number.isInteger)
        .filter((id) => !state[key][id]);

      if (!searchedIds.length) return;

      const params = { 'search[id]': searchedIds.join(',') };

      const response = await CACHE_REQUESTS[key](params);

      if (response.data) commit('ADD_TO_CACHE', { key, data: response.data.data });
    },
  },
  mutations: {
    ADD_TO_CACHE(state, items) {
      const { key, data } = items;
      data.forEach((item) => {
        state[key][item.id] = item;
      });
    },

    UPDATE_CACHE(state, item) {
      const { key, data } = item;
      state[key][data.id] = data;
    },

    DELETE_CACHE(state, item) {
      const { key, id } = item;
      delete state[key][id];
    },

  },
};
